import React from 'react'

import { deepOrange, green, orange, teal } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'
import { PaletteColorOptions } from '@mui/material/styles/createPalette'

// TODO this File should be removed after redesign  (kas)

export const customPalette = {
  paragraphGrey: '#7E7E7E',
  foreground: {
    default: '#1A1A1A',
    secondary: '#3D3D3D',
    tertiary: '#7E7E7E',
    disabled: '#E0E0E0',
    grey1: '#959595',
  },
  border: {
    default: '#EBEBEB',
    tertiary: '#BEBEBE',
  },
  background: {
    default: '#FFFFFF',
    contrast: '#E0E0E0',
    secondary: '#F8F8F8',
  },
  signal: {
    error: '#EA3546',
    errorBg: '#FFEFF1',
    warning: '#CD6717',
    warningBg: '#FBE8D5',
  },
  icons: {
    default: '#1A1A1A',
    brand: '#188E9D',
    secondary: '#7E7E7E',
  },
  secondary: {
    accent: {
      lightTeal: '#E8F4F5',
      teal: '#F3F9FA',
      lightGraceOrange: '#FFF8E9',
      mediumGraceOrange: '#FEDBAD',
      lightGraceGreen: '#E8F8F8',
      mediumGraceGreen: '#D4EFF0',
      lightRust: '#FBE8D5',
      lightPetrol: '#D1E8EB',
      brown: '#E8D6D2',
      other: '#E8AB03',
    },
  },
  primary: {
    accent: {
      teal: '#188E9D',
      teal10p: '#188E9D1A',
      tealGradient: 'linear-gradient(90deg, #33AECA 0%, #195664 100%)',
      graceOrange: '#EEA358',
      graceGreen: '#17BDC3',
      yellow: '#E6BF52',
      rust: '#B34B12',
      maroon: '#5F1707',
      petrol: '#195664',
      other: '#FFFAEE',
    },
  },
  linearProgress: {
    background: '#b2dfdb',
    barBackgroundColor: '#3297A5',
  },
  stepper: {
    background: '#3297a514',
  },
  accent: {
    light: teal[200],
    main: teal[300],
    dark: teal[400],
  },
  panel: {
    selected: {
      row: deepOrange[50],
    },
  },
  success: {
    main: green[500],
  },
  warning: {
    main: orange[500],
  },
  danger: {
    main: '#D00026',
  },
  black: '#000000',
  white: '#FFFFFF',
  lightGrey: 'rgba(0, 0, 0, 0.6)',
  lightGrey2: 'rgba(0, 0, 0, 0.54)',
  lightGrey3: 'rgba(0, 0, 0, 0.24)',
  lightGrey4: 'rgba(0, 0, 0, 0.16)',
  lightGrey5: '#fdfdfd',
  lightGrey6: '#f8f8f8',
  lightGrey7: 'rgba(0, 0, 0, 0.38)',
  lightGrey8: 'rgba(33, 33, 33, 0.04)',
  lightGrey9: '#F3F3F3',
  lightGrey10: '#F7F7F7',
  lightGrey11: '#EAEAEA',
  lightGrey12: 'rgba(0, 0, 0, 0.08)',
  lightGrey13: 'rgba(0, 0, 0, 0.32)',
  lightGrey14: 'rgba(0, 0, 0, 0.06)',
  lightGrey15: 'rgba(0, 0, 0, 0.65)',
  lightGrey16: 'rgba(0, 0, 0, 0.87)',
  lightGrey17: '#555555',
  lightGrey18: '#fbfbfb',
  transparentWhite: 'rgba(255, 255, 255, .6)',
  linkBlue: '#3297A5',
  actionLinkBlue: '#0067A8',
  lightBlue: '#B9DEF5',
  lightBlue2: '#D5F2FF',
  bgConicGradient: 'conic-gradient(from 124deg at 50% 38.39%, #fbfbfb 0deg, #f5f5f5 360deg)',
  status: {
    unknown: {
      background: 'grey',
    },
    stopped: {
      background: '#b00020',
    },
    pending: {
      background: '#e36f32',
    },
    running: {
      background: '#f1f1f1',
    },
    failed: {
      background: '#B00020',
    },
    success: {
      background: '#07bc0c',
    },
  },
  notificationMessage: {
    warning: 'rgba(227, 111, 50, 0.12)',
    error: 'rgba(176, 0, 32, 0.06)',
    errorDarker: 'rgba(176, 0, 32, 0.24)',
    success: green[500],
  },
  auditorStatsColors: {
    danger: '#FF5252',
    warning: '#FFE082',
    optimal: '#ACE9CF',
  },
  menu: {
    background: '#FFFFFF',
    topBar: '#2B4151',
    leftIcons: '#7E7E7E',
    topIcons: '#ffffff',
    text: '#ffffff',
    selected: 'rgba(227, 111, 50, 0.2)',
  },
  levels: {
    danger: '#FF0000',
    warning: '#FFA800',
    optimal: '#00BC58',
  },
  importance: {
    all: '#E0E0E0',
    low: '#EEA358',
    medium: '#B34B12',
    high: '#5F1707',
  },
  riskLevel: {
    low: '#4CAF50',
    medium: '#FF8F00',
    high: '#E91E63',
  },
  phases: {
    nonStarted: '#e36f32',
    draft: '#2b4151',
    completed: '#5bacb7',
  },
  achievements: {
    obtained: '#D5F2FF',
    retry: '#FFE9EE',
  },
}

const chipsPalette = {
  green: '#3297A5',
  red: '#D00026',
  lightGreen: 'rgba(50, 151, 165, 0.12)',
  lightRed: 'rgba(208, 0, 38, 0.16)',
  orange: '#E36F32',
  black: '#494949',
  default: 'rgba(0, 0, 0, 0.06)',
  hoverColors: {
    green: 'rgba(50, 151, 165, 0.8)',
    red: 'rgba(208, 0, 38, 0.8)',
    lightGreen: 'rgba(50, 151, 165, 0.24)',
    lightRed: 'rgba(208, 0, 38, 0.24)',
    orange: 'rgba(227, 111, 50, 0.8)',
    black: 'rgba(0, 0, 0, 0.8)',
    default: 'rgba(0, 0, 0, 0.12)',
  },
}

const chartsPalette = {
  colors: {
    default: '#5E77FF',
  },
  pie: {
    colors: ['#5072F8', '#6583FA', '#6E8AFB', '#7F97FB', '#94A8FB', '#9EB0FC', '#AFBEFC', '#C1CCFD', '#CAD4FD'],
    pie2Color: '#455A64',
    pie2BgColor: '#E9E9E9',
  },
  bar: {
    color: '#78909C',
  },
}

const sizes = {
  sidebar: {
    miniMode: '72px',
    fullWidth: '272px',
  },
  scrollbar: {
    size: '6px',
    borderRadius: '3px',
  },
  header: {
    size: '64px',
  },
  dataTable: {
    header: '48px',
    actionBar: '72px',
  },
  formLayout: {
    leftColumnWidth: 212,
    narrowFormBoxWidth: 448,
    formBoxWidth: 636,
  },
}

declare module '@mui/material/styles' {
  interface Theme {
    sizes: typeof sizes
  }

  interface ThemeOptions {
    sizes?: typeof sizes
  }

  interface Palette {
    custom: typeof customPalette
    charts: typeof chartsPalette
    chips: typeof chipsPalette
  }

  interface PaletteOptions {
    custom?: typeof customPalette
    charts?: typeof chartsPalette
    chips?: typeof chipsPalette
    blueGrey: PaletteColorOptions
  }

  interface TypographyVariants {
    body3: React.CSSProperties
    body4: React.CSSProperties
    paragraph: React.CSSProperties
    subtitle3: React.CSSProperties
  }

  interface TypographyVariantsOptions {
    body3: React.CSSProperties
    body4: React.CSSProperties
    paragraph?: React.CSSProperties
    subtitle3: React.CSSProperties
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    paragraph: true
    body3: true
    body4: true
    subtitle3: true
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    blueGrey: true
  }
  interface ButtonPropsVariantOverrides {
    blueGrey: true
  }
}

// follow this structure https://material-ui.com/customization/default-theme/
// put custom variables in `custom` property of the corresponding piece of the theme
export const getTheme = (colors?: Record<string, Record<string, string>>) => {
  return createTheme({
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            background: colors?.menu?.background,
          },
        },
      },
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            backgroundColor: customPalette.linearProgress.background,
          },
          barColorPrimary: {
            backgroundColor: customPalette.linearProgress.barBackgroundColor,
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            '&$expanded': {
              margin: '8px 0 10px',
              boxShadow: '0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2)',
            },
          },
          expanded: {},
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            paddingTop: '5px !important',
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          content: {
            margin: '4px 0',
          },
          root: {
            padding: '0 26px 0 16px',
            minHeight: '56px',
            '&$expanded': {
              borderBottom: '1px solid rgba(0, 0, 0, 0.16)',
            },
          },
          expanded: {},
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            padding: '16px 24px 24px',
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            padding: 6,
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fontSize: 24,
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            paddingTop: 9,
            paddingBottom: 9,
          },
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            minWidth: 'auto',
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          root: {
            padding: '0 16px',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            height: '28px',
            backgroundColor: 'rgba(0, 0, 0, 0.06)',
            color: 'rgba(0, 0, 0, 0.87)',
            '&.MuiChip-filledError': {
              color: '#D00026',
            },
          },
          outlined: {
            borderColor: '#3297A5',
          },
          label: {
            color: 'inherit',
            fontSize: '12.5px',
            letterSpacing: '0.23px',
            lineHeight: '17px',
          },
          deleteIcon: {
            color: 'rgba(0, 0, 0, 0.16)',
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            '& > fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.6)',
            },
            height: '40px',
            fontSize: '1.1rem',
            background: customPalette.white,
          },
          multiline: {
            height: 'unset',
          },
          formControl: {
            marginBottom: '14px',
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            '&.Mui-error': {
              color: '#b00020 !important',
            },
          },
          contained: {
            margin: '-10px 12px 0',
            lineHeight: '10px',
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontWeight: 'normal',
            color: customPalette.lightGrey,
            fontSize: 13.6,
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            background: customPalette.white,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderColor: 'rgba(255,0,0, 0.6)',
            // TODO: remove when issue solved: a workaround for this issue: https://github.com/mui/material-ui/issues/32934
            'input[required] + fieldset > legend > span': {
              paddingRight: 0,
              margin: '-1px',
            },
            '&.Mui-error': {
              color: '#d00026 !important',
              '& $.MuiOutlinedInput-notchedOutline': {
                borderColor: '#d00026 !important',
              },
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e36f32 !important',
            },
            '&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e36f32',
            },
          },
          input: {
            fontSize: '1.1rem',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            '&.Mui-error': {
              color: '#b00020 !important',
            },
          },
          outlined: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            minHeight: '16px',
            '&.Mui-focused': {
              color: '#e36f32 !important',
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: 'rgba(0, 0, 0, 0.54)',
            '&.Mui-focused': {
              color: '#e36f32',
            },
            '&.Mui-disabled': {
              color: 'rgba(0,0,0,0.4) !important',
            },
          },
          asterisk: {
            display: 'none',
          },
          filled: {
            color: '#e36f32',
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            '&.Mui-checked': {
              color: '#e36f32 !important',
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            '&$labelPlacementStart': {
              margin: 0,
            },
          },
          label: {
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: 13.6,
            letterSpacing: '0.25px',
            lineHeight: '20px',
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            lineHeight: '1.3em',
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: '6px',
          },
        },
      },
      MuiButton: {
        variants: [
          {
            props: { variant: 'contained', color: 'blueGrey' },
            style: {
              color: '#fff',
            },
          },
          {
            props: { variant: 'contained', color: 'error' },
            style: {
              color: '#fff',
            },
          },
        ],
        styleOverrides: {
          root: {
            '&$disabled': {
              color: 'rgba(227,111,50,0.38)',
            },
          },
          contained: {
            '&$disabled': {
              backgroundColor: 'rgba(227, 111, 50, 0.3)',
              color: '#fff',
            },
          },
          outlined: {
            backgroundColor: '#fff',
            color: '#344054',
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: {
            '&.MuiAutocomplete-inputRoot': {
              minHeight: '30px',
            },
          },
          inputRoot: {
            height: 'unset',
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            padding: '18px 24px 24px',
          },
        },
      },
      MuiCircularProgress: {
        styleOverrides: {
          root: {
            color: '#3297A5',
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            '&:last-child': {
              paddingBottom: '18px',
            },
          },
        },
      },
    },
    palette: {
      custom: {
        ...customPalette,
        menu: {
          background: colors?.menu?.background || customPalette.menu.background,
          topBar: colors?.menu?.topBar || customPalette.menu.topBar,
          leftIcons: colors?.menu?.leftIcons || customPalette.menu.leftIcons,
          topIcons: colors?.menu?.topIcons || customPalette.menu.topIcons,
          text: colors?.menu?.text || customPalette.menu.text,
          selected: colors?.menu?.selected || customPalette.menu.selected,
        },
      },
      divider: 'rgba(0, 0, 0, .16)',
      primary: {
        main: '#494949',
      },
      secondary: {
        light: '#F2B899',
        main: '#e36f32',
      },
      blueGrey: {
        light: '#FFFFFF',
        main: '#546E7A',
      },
      background: {
        default: '#f1f1f1',
      },
      error: {
        main: '#b00020',
      },
      charts: chartsPalette,
      chips: chipsPalette,
    },
    typography: {
      fontFamily: '"Inter", "Noto Sans JP", sans-serif',
      fontSize: 13.6,
      h1: {
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '45px',
        letterSpacing: '.44px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      h2: {
        fontSize: '28px',
        fontWeight: 600,
        lineHeight: '39px',
        letterSpacing: '.38px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      h3: {
        fontSize: '25px',
        fontWeight: 600,
        lineHeight: '35px',
        letterSpacing: '.34px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      h4: {
        fontSize: '22px',
        fontWeight: 600,
        lineHeight: '30px',
        letterSpacing: '.3px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      h5: {
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '27px',
        letterSpacing: '.25px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      h6: {
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '.25px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      body1: {
        fontSize: '15.5px',
        fontWeight: 400,
        lineHeight: '23px',
        letterSpacing: '.5px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      body2: {
        fontSize: '13.6px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '.25px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      body3: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        letterSpacing: '.25px',
        color: '#667085',
      },
      body4: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '.25px',
        color: '#667085',
      },
      subtitle1: {
        fontSize: '15.4px',
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '.15px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      subtitle2: {
        fontSize: '13.5px',
        fontWeight: 600,
        lineHeight: '21px',
        letterSpacing: '.1px',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      subtitle3: {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '22px',
        letterSpacing: '0.2px',
      },
      caption: {
        fontSize: '11px',
        fontWeight: 400,
        lineHeight: '15px',
        letterSpacing: '.38px',
        color: 'rgba(0, 0, 0, 0.54)',
      },
      overline: {
        fontSize: '11.53px',
        fontWeight: 600,
        lineHeight: '16px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      button: {
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '1.3px',
        fontWeight: 600,
        textTransform: 'uppercase',
        color: 'rgba(0, 0, 0, 0.87)',
      },
      paragraph: {
        color: '#000000',
        fontSize: '13.5px',
        fontWeight: 400,
        lineHeight: '15px',
        letterSpacing: '0.38px',
      },
    },
    sizes,
  })
}
